<div class="container-image no-print">
    <img loading="lazy" *ngIf="imageSrc" [src]="imageSrc" [alt]="block.testo_alt">
</div>
<app-sample-print [imageUrl]="imageSrc"></app-sample-print>